import React from 'react'
import WTextField from './WTextField'
import WCurrencyField from './WCurrencyField'
import WDateField from './WDateField'
import WDateTimeField from './WDateTimeField'
import WEmailField from './WEmailField'
import WMemoField from './WMemoField'
import WNumericField from './WNumericField'
import WPhoneField from './WPhoneField'
import WSignatureField from './WSignatureField'
import WURLField from './WURLField'
import WYesNoField from './WYesNoField'
import WAPUserField from './WAPUserField'
import WListField from './WListField'
import WMultipleListField from './WMultipleListField'
import WEntityListField from './WEntityListField'
import WMultipleEntityListField from './WMultipleEntityListField'
import WDateDurationField from './WDateDurationField'

export default function WizardAdditionalFields({
  data,
  fieldType,
  fieldId,
  onChange = (e, key, value) => {},
}) {
  switch (fieldType) {
    case 'TextField':
      return <WTextField onChange={onChange} data={data} />
    case 'CurrencyField':
      return <WCurrencyField onChange={onChange} data={data} />
    case 'DateField':
      return <WDateField onChange={onChange} data={data} />
    case 'DateTimeField':
      return <WDateTimeField onChange={onChange} data={data} />
    case 'EmailField':
      return <WEmailField onChange={onChange} data={data} />
    case 'MemoField':
      return <WMemoField onChange={onChange} data={data} />
    case 'NumericField':
      return <WNumericField onChange={onChange} data={data} />
    case 'PhoneField':
      return <WPhoneField onChange={onChange} data={data} />
    case 'SignatureField':
      return <WSignatureField onChange={onChange} data={data} />
    case 'UrlField':
      return <WURLField onChange={onChange} data={data} />
    case 'YesNoField':
      return <WYesNoField onChange={onChange} data={data} />
    case 'ApUserField':
      return <WAPUserField onChange={onChange} data={data} />
    case 'ListField':
      return <WListField onChange={onChange} data={data} />
    case 'MultipleListField':
      return <WMultipleListField onChange={onChange} data={data} />
    case 'EntityListField':
      return <WEntityListField onChange={onChange} data={data} />
    case 'MultipleEntityListField':
      return (
        <WMultipleEntityListField
          onChange={onChange}
          data={data}
          fieldType={fieldType}
          fieldId={fieldId}
        />
      )
    case 'DateDurationField':
      return <WDateDurationField onChange={onChange} data={data} />
    default:
      return null
  }
}
